/** Preferência: usuário já ativou Modo Prestador ao menos uma vez (pode ter desligado depois). */
export function jaAtivouModoPrestador(user) {
  if (!user) return false;
  if (user.modo_prestador_ativo) return true;
  const prefs = user.preferencias_ui;
  return Boolean(prefs && typeof prefs === 'object' && prefs.modo_prestador_ja_ativado);
}

export function perfilPrestadorRespondido(user) {
  if (!user) return false;
  if (user.modo_prestador_ativo) return true;
  const prefs = user.preferencias_ui;
  return Boolean(prefs && typeof prefs === 'object' && prefs.modo_prestador_perfil_respondido);
}

/**
 * Ativa Modo Prestador e marca histórico em preferencias_ui (merge no backend).
 * @param {(payload: object) => Promise<unknown>} updatePerfil
 */
export async function ativarModoPrestador(updatePerfil) {
  return updatePerfil({
    modo_prestador_ativo: true,
    preferencias_ui: {
      modo_prestador_ja_ativado: true,
      modo_prestador_perfil_respondido: true,
    },
  });
}

/** Marca que a pergunta de perfil foi respondida sem ativar o modo. */
export async function recusarModoPrestadorPerfil(updatePerfil) {
  return updatePerfil({
    preferencias_ui: {
      modo_prestador_perfil_respondido: true,
    },
  });
}

export const PRESTADOR_BANNER_MIN_COBRANCAS = 3;
